import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const SUCCESS_STORIES = [
  { couple: 'Rajesh & Priya', location: 'Salem', text: 'We met through Suvaran Maran Matrimony and our families connected quickly. The platform made our journey simple and meaningful.', emoji: '💑' },
  { couple: 'Karthik & Divya', location: 'Coimbatore', text: 'We found a genuine profile and our families arranged the marriage. Thank you for helping us find the right partner.', emoji: '🥰' },
  { couple: 'Arun & Meena', location: 'Chennai', text: 'The platform is easy to use and helped us find the right match. We highly recommend Suvaran Maran Matrimony.', emoji: '💍' },
];

const FEATURES = [
  { icon: '🛡️', title: 'Trusted Platform', titleTa: 'நம்பகமான தளம்', desc: 'Safe and reliable platform where brides and grooms can search for genuine marriage alliances.' },
  { icon: '⭐', title: 'Star Auto Matching', titleTa: 'நட்சத்திர பொருத்தம்', desc: 'Our unique algorithm auto-matches by horoscope type — Sutham only sees Sutham profiles.' },
  { icon: '🔒', title: 'Privacy & Security', titleTa: 'தனியுரிமை பாதுகாப்பு', desc: 'Contact numbers are hidden until both parties agree. Your data is fully protected.' },
  { icon: '✅', title: 'Verified Profiles', titleTa: 'சரிபார்க்கப்பட்ட சுயவிவரங்கள்', desc: 'Every profile is manually verified by our admin team before being shown to members.' },
];

const HOROSCOPE_TYPES = [
  { type: 'Sutham', color: '#856404', bg: '#fff3cd', desc: 'Sutham profiles only shown to Sutham' },
  { type: 'Seva', color: '#0c5460', bg: '#d1ecf1', desc: 'Seva matches with Seva families' },
  { type: 'Rahu Ketu', color: '#721c24', bg: '#f8d7da', desc: 'Rahu Ketu exclusive matching' },
  { type: 'Seva, Rahu Ketu', color: '#4a235a', bg: '#e2d9f3', desc: 'Compatible cross-matching' },
];

export default function Home() {
  const [count, setCount] = useState({ profiles: 0, marriages: 0, stars: 0 });

  useEffect(() => {
    const target = { profiles: 2547, marriages: 847, stars: 27 };
    const dur = 2000; const steps = 60;
    let step = 0;
    const t = setInterval(() => {
      step++;
      const prog = step / steps;
      setCount({
        profiles:  Math.floor(prog * target.profiles),
        marriages: Math.floor(prog * target.marriages),
        stars:     Math.floor(prog * target.stars),
      });
      if (step >= steps) { clearInterval(t); setCount(target); }
    }, dur / steps);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="home-page">
      {/* ── HERO ── */}
      <section className="hero">
        <div className="hero-bg-pattern" />
        <div className="hero-content container">
          <div className="hero-badge">🪷 Tamil Hindu Matrimony</div>
          <h1 className="hero-title">
            Find Your Perfect<br />
            <span className="hero-title-gold">Life Partner</span>
          </h1>
          <p className="hero-tamil">உங்கள் வாழ்க்கை துணையை கண்டறியுங்கள்</p>
          <p className="hero-subtitle">
            Trusted Matrimony Platform for Brides and Grooms.<br />
            With our unique <strong>Horoscope Type Matching</strong>, find your perfect match.
          </p>
          <div className="hero-actions">
            <Link to="/register" className="btn btn-gold btn-lg">🪷 Create Free Profile</Link>
            <Link to="/login" className="btn btn-outline-gold btn-lg">Browse Profiles →</Link>
          </div>
          {/* Stats */}
          <div className="hero-stats">
            <div className="stat-item"><strong>{count.profiles.toLocaleString()}</strong><span>Profiles</span></div>
            <div className="stat-divider" />
            <div className="stat-item"><strong>{count.marriages.toLocaleString()}</strong><span>Marriages</span></div>
            <div className="stat-divider" />
            <div className="stat-item"><strong>{count.stars}</strong><span>Nakshatras</span></div>
          </div>
        </div>
        <div className="hero-scroll-hint">↓</div>
      </section>

      {/* ── HOROSCOPE TYPE SYSTEM ── */}
      <section className="section-types">
        <div className="container">
          <div className="text-center">
            <h2 className="section-title">Our Unique Matching System</h2>
            <div className="gold-divider" />
            <p className="section-subtitle">Horoscope type filtering ensures you only see truly compatible profiles</p>
          </div>
          <div className="types-grid">
            {HOROSCOPE_TYPES.map(t => (
              <div key={t.type} className="type-card" style={{ borderColor: t.color, background: t.bg }}>
                <div className="type-name" style={{ color: t.color }}>{t.type}</div>
                <p style={{ color: t.color, opacity: 0.8 }}>{t.desc}</p>
              </div>
            ))}
          </div>
          <p className="types-note">
            🛡️ <strong>Sutham Shield Guarantee:</strong> Sutham profiles are ONLY shown to Sutham members. 100% guaranteed. Never mixed.
          </p>
        </div>
      </section>

      {/* ── HOW IT WORKS ── */}
      <section className="section-how">
        <div className="container">
          <div className="text-center">
            <h2 className="section-title">How It Works</h2>
            <div className="gold-divider" />
          </div>
          <div className="steps-grid">
            {[
              { n: '01', icon: '📝', title: 'Create Your Profile', titleTa: 'சுயவிவரம் உருவாக்கவும்', desc: 'Register and fill in your personal, horoscope and family details.' },
              { n: '02', icon: '💳', title: 'Pay ₹499 Once', titleTa: '₹499 ஒரே தடவை செலுத்தவும்', desc: 'One-time lifetime payment. No hidden charges. Admin verifies your profile.' },
              { n: '03', icon: '🔍', title: 'Browse Matches', titleTa: 'பொருத்தங்களை உலாவவும்', desc: 'Get auto-filtered profiles based on your horoscope type with match scores.' },
              { n: '04', icon: '💑', title: 'Connect & Marry', titleTa: 'இணைந்து திருமணம் செய்யுங்கள்', desc: 'Send contact request. Other person approves. Connect and start your journey.' },
            ].map(s => (
              <div key={s.n} className="step-card">
                <div className="step-number">{s.n}</div>
                <div className="step-icon">{s.icon}</div>
                <h3>{s.title}</h3>
                <p className="step-tamil">{s.titleTa}</p>
                <p>{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── FEATURES ── */}
      <section className="section-features">
        <div className="container">
          <div className="text-center">
            <h2 className="section-title">Why Choose Suvaran Maran Matrimony</h2>
            <div className="gold-divider" />
          </div>
          <div className="features-grid">
            {FEATURES.map(f => (
              <div key={f.title} className="feature-card">
                <div className="feature-icon">{f.icon}</div>
                <h3>{f.title}</h3>
                <p className="feature-tamil">{f.titleTa}</p>
                <p>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── SUCCESS STORIES ── */}
      <section className="section-stories">
        <div className="container">
          <div className="text-center">
            <h2 className="section-title" style={{ color: 'var(--gold)' }}>Happy Couples</h2>
            <div className="gold-divider" />
            <p className="section-subtitle" style={{ color: 'rgba(217,196,169,0.8)' }}>
              Thousands of people trust Suvaran Maran Matrimony to find their life partners.
            </p>
          </div>
          <div className="stories-grid">
            {SUCCESS_STORIES.map(s => (
              <div key={s.couple} className="story-card">
                <div className="story-emoji">{s.emoji}</div>
                <p className="story-text">"{s.text}"</p>
                <div className="story-couple">
                  <strong>{s.couple}</strong>
                  <span>📍 {s.location}</span>
                </div>
                <div className="story-stars">★★★★★</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="section-cta">
        <div className="container text-center">
          <h2 className="section-title">Start Your Marriage Journey Today</h2>
          <div className="gold-divider" />
          <p>Create your profile today and take the first step towards finding your perfect life partner.</p>
          <div className="cta-actions">
            <Link to="/register" className="btn btn-gold btn-lg">🪷 Create Free Profile</Link>
            <Link to="/plan" className="btn btn-outline btn-lg">View Plan & Pricing</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
